var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0837 2.25016C15.0837 1.471 14.4462 0.833496 13.667 0.833496H2.33366C1.55449 0.833496 0.916992 1.471 0.916992 2.25016M15.0837 2.25016V10.7502C15.0837 11.5293 14.4462 12.1668 13.667 12.1668H2.33366C1.55449 12.1668 0.916992 11.5293 0.916992 10.7502V2.25016M15.0837 2.25016L8.00033 7.2085L0.916992 2.25016",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.27bc2b0010f0cc957e4ae5081a85f897.svg";
export { ForwardRef as ReactComponent };